import { render, staticRenderFns } from "./zhiwei.vue?vue&type=template&id=0ee124ae&scoped=true&"
import script from "./zhiwei.vue?vue&type=script&lang=js&"
export * from "./zhiwei.vue?vue&type=script&lang=js&"
import style0 from "./zhiwei.vue?vue&type=style&index=0&id=0ee124ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee124ae",
  null
  
)

export default component.exports